<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division">
<h1 class="chapter_fm1" id="c17"><span class="chapter_fm1">c. 900</span></h1>
<h1 class="chapter01">Alchemy</h1>
<p class="seealso_fm2"><strong>Abu Bakr Muhammad ibn Zakariya’ al-Razi</strong> (865−925)</p>
<p class="nonindent">The Persian polymath al-Razi is one of the most famous of the alchemists, and his writings show how much modern chemistry was mixed into the beliefs of his time. As would be expected, he worked tirelessly to understand what made metals different from one another and from the nonmetals. Although he never claimed to have produced gold from base metals, he described how to make metals <em>look</em> like gold. He then went on to classify other substances into such categories as vitriols, salts, stones, spirits, etc., and to catalog their properties (e.g., how easily they melted or caught fire). Along the way, he rejected the classical <strong><a class="hlink" href="#/Text/c07">four elements</a></strong> in favor of his more complex arrangement. Paying close attention to such similarities and differences is absolutely central to chemistry.</p>
<p class="indent">Al-Razi is also notable for rejecting magical explanations and the idea of manipulating the physical world through symbols rather than through physical causes. His greatest contribution in the history of chemistry comes from his book <em>Kitab al-asrar</em> (<em>The Book Secrets</em>), which revealed how dedicated he was to experimentation with real substances. With lengthy, detailed description of his apparatus, the book explained the uses of crucibles, tongs, bellows, flasks, funnels, mortars, heating baths, and more, offering his contemporaries a look at his state-of-the-art equipment and giving modern-day chemists an intimate view of a working lab from over a thousand years ago. Some of the experimenters who came after al-Razi adopted his classification scheme, while others disagreed or made their own. But for centuries to come, <em>Kitab al-asrar</em> was the closest thing that alchemy had to a standard laboratory equipment manual.</p>
<p class="seealso"><strong>SEE ALSO</strong> <a class="hlink" href="#/Text/c06">Gold Refining (c. 550 BCE)</a>, <a class="hlink" href="#/Text/c07">The Four Elements (c. 450 BCE)</a>, <a class="hlink" href="#/Text/c14">The Philosopher’s Stone (c. 800)</a>, <a class="hlink" href="#/Text/c16">Gunpowder (c. 850)</a>, <span class="hlink" href="#/Text/c26" title="Link target outside of Sample"><em>The Sceptical Chymist</em> (1661)</span></p>
<div class="image">
<div class="dis_img"><img alt="" src="Images/047.jpg"/></div>
<p class="caption">As fires rage in buildings and mines in the background, a goddess warns an alchemist of the element’s dangers.</p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c17.vue?b4cdec66